import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';

import { EntityBackupDefinitionApi } from './models/back/entity-backup-definition-api';
import { EntityMaster } from '../domain/models/back/entity-backup-definition';
import { EntityComputeDefinitionApi } from './models/back/entity-compute-definition-api';
import { EntityComputeDefinition, VboFilter, VeeamFilter, VmwareFilter } from '../domain/models/back/entity-compute-definition';

@Injectable({
    providedIn: 'root'
})
export class EntityQueryDefinitionsApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.segmentApi = '/hist/querydefinitions';
    }

    getBackupDefinitions (entityId: string): Observable<EntityBackupDefinitionApi>
    {
        return this.get<EntityBackupDefinitionApi>(`/backup/${entityId}`);
    }

    updateBackupDefinitions (entityId: string, BackupDefinitions: EntityMaster[]): Observable<EntityBackupDefinitionApi>
    {
        return this.post<EntityBackupDefinitionApi>('/backup', { entityId: entityId, BackupDefinitions: BackupDefinitions });
    }

    getComputeDefinition (entityId: string): Observable<EntityComputeDefinitionApi>
    {
        return this.get<EntityComputeDefinitionApi>(`/compute/${entityId}`);
    }

    updateWmwareDefinition (entityId: string, vmwareFilters: VmwareFilter[]): Observable<EntityComputeDefinitionApi>
    {
        return this.post<EntityComputeDefinitionApi>(`/compute/vmware/${entityId}`, vmwareFilters);
    }

    updateVeeamDefinition (entityId: string, veeamFilters: VeeamFilter[]): Observable<EntityComputeDefinitionApi>
    {
        return this.post<EntityComputeDefinitionApi>(`/compute/veeam/${entityId}`, veeamFilters);
    }

    updateVboDefinition (entityId: string, vboFilters: VboFilter[]): Observable<EntityComputeDefinitionApi>
    {
        return this.post<EntityComputeDefinitionApi>(`/compute/vbo/${entityId}`, vboFilters);
    }

}
